import React from 'react';
import { makeStyles, Theme, createStyles, useTheme } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import { red } from '@material-ui/core/colors';
import { Caixa } from '../../models/caixa';
import { MoreVertIcon } from '../../components/AppIcons';
import { CaixaDetalhes } from './CaixaDetalhes';
import Button from '@material-ui/core/Button';
import { Litros, Reais } from '../../components/numberUtils';
import { IndicadorFlat } from '../../components/Indicador';
import { FullScreenDialog } from '../../components/FullScreenDialog';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
    },
    media: {
      height: 0,
      paddingTop: '56.25%', // 16:9
    },
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
    },
    expandOpen: {
      transform: 'rotate(180deg)',
    },
    avatar: {
      backgroundColor: red[500],
    },

    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '33.33%',
      flexShrink: 0,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
  }),
);

export interface CaixaWidgetCardProps {
  caixa: Caixa;
}

export const CaixaWidget = ({ caixa }: CaixaWidgetCardProps) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const descricao = `E${caixa.empresaCod} Turno ${caixa.turno} ${caixa.operadorNome}`;

  const situacao = caixa.dataFechamento
    ? 'Fechado às ' + new Date(caixa.dataFechamento).toLocaleTimeString('pt-br')
    : 'Aberto';

  const totLitros = caixa.vendasCombustiveis.reduce((a, b) => a + b.quantidade, 0);

  // const totCombustiveis = caixa.vendasCombustiveis.reduce((a, b) => a + b.totalLiquido, 0);

  // const totProdutos = caixa.vendasProdutos.reduce((a, b) => a + b.totalLiquido, 0);

  const totCountAba = caixa.vendasCombustiveis.reduce((a, b) => a + b.contagem, 0);

  return (
    <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            {caixa.turno}
          </Avatar>
        }
        action={
          <IconButton aria-label="settings" onClick={handleExpandClick}>
            <MoreVertIcon />
          </IconButton>
        }
        title={descricao}
        subheader={situacao}
      />
      {/* <CardMedia
                className={classes.media}
                image="/static/images/cards/paella.jpg"
                title="Paella dish"
            /> */}
      <CardContent>

        <IndicadorFlat valor={<Reais valor={caixa.geral.totalLiquido} />} titulo="Total Liquido" />
        <IndicadorFlat valor={<Litros valor={totLitros} />} titulo="Litros" />
        <IndicadorFlat valor={totCountAba} titulo="# Abastecimentos" />
      </CardContent>
      <CardActions disableSpacing>

        <Button size="small" color="primary" onClick={handleExpandClick}>
          Detalhes do Caixa
                </Button>
      </CardActions>

      <FullScreenDialog fullScreen={fullScreen} open={expanded} title="Detalhes do caixa" handleClose={handleExpandClick}>
        <CaixaDetalhes caixa={caixa} />
      </FullScreenDialog>

    </Card>
  );
}
